// extracted by mini-css-extract-plugin
export var addressFields = "_ox-0";
export var animationContainer = "_ox-1";
export var footer = "_ox-2";
export var lineItems = "_ox-3";
export var modalContent = "_ox-4";
export var orderName = "_ox-5";
export var strong = "_ox-6";
export var warning = "_ox-7";